import { createFileRoute, redirect } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { z } from "zod"

import { useAuthStore } from "@/features/auth/store"
import { canAccessHemsSshDevices } from "@/features/hems-ssh-devices/access"
import { HemsSshAgentDownload } from "@/features/hems-ssh-devices/components/HemsSshAgentDownload"
import { HemsSshDevicesTable } from "@/features/hems-ssh-devices/components/HemsSshDevicesTable"

const searchSchema = z.object({
  device: z.number().int().optional(),
  status: z.string().optional(),
})

export const Route = createFileRoute("/_authed/ssh-devices")({
  // Roller gelene kadar geçici: sadece süper admin (e-posta allowlist).
  // URL'e doğrudan gidilse bile yetkisiz kullanıcı dashboard'a yönlenir.
  beforeLoad: () => {
    if (!canAccessHemsSshDevices(useAuthStore.getState().user?.email)) {
      throw redirect({ to: "/dashboard" })
    }
  },
  component: HemsSshDevicesPage,
  validateSearch: (raw) => searchSchema.parse(raw),
})

function HemsSshDevicesPage() {
  const { t } = useTranslation("hems-ssh-devices")
  const { device, status } = Route.useSearch()
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="flex items-start justify-between gap-4 border-b border-ok-border px-6 py-4">
        <div className="min-w-0">
          <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
          <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
        </div>
        <HemsSshAgentDownload />
      </div>
      <HemsSshDevicesTable
        initialSelectedId={device ?? null}
        initialStatus={status ?? null}
      />
    </div>
  )
}
